var scope_0 = require('C:/Projects/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/399c37e72be35af3884933e284685017.js').default;
var scope_1 = require('C:/Projects/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5f3331e9f1bd7b4fd2a5a52db3382987.js').default;
var scope_2 = require('C:/Projects/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    